module.exports = __webpack_public_path__ + "static/media/anaLogySecond.8c39a522.svg";